export default class CaptionSwitcher {

    constructor() {
        this.$captionSwitcher = document.querySelector('[data-caption-switcher]');
        if (!this.$captionSwitcher) {
            return;
        }
        this.$swiper = this.$captionSwitcher.querySelector('.swiper');
        if (!this.$swiper) {
            console.warn('No swiper carousel found within caption switcher. Caption switcher module will not be run.');
            return;
        }
        this.$captionSwitcherTargets = this.$captionSwitcher.querySelectorAll('[data-caption-switcher-target]');
        this.setup();
    }
    setTargetAsActive($target) {
        $target.setAttribute('data-caption-switcher-active', undefined);
        const event = new Event('caption-switcher-target-active');
        $target.dispatchEvent(event);
    }
    setTargetAsInactive($target) {
        $target.removeAttribute('data-caption-switcher-active');
        const event = new Event('caption-switcher-target-inactive');
        $target.dispatchEvent(event);
    }
    getActiveId() {
        const $active = this.$swiper.querySelector('.swiper-slide-active');
        if ($active != null) {
            return $active.querySelector('[data-caption-switcher-select]').dataset.captionSwitcherSelect;
        }
    }
    setInitialActiveCaption() {
        const active = this.getActiveId();
        this.$captionSwitcherTargets.forEach($target => {
            if ($target.dataset.captionSwitcherTarget === active) {
                requestAnimationFrame(() => {
                    this.setTargetAsActive($target);
                });
            }
        });
    }
    eventBindings() {
        this.$swiper.addEventListener('real-index-change', () => {
            requestAnimationFrame(() => {
                const id = this.getActiveId();
                this.$captionSwitcherTargets.forEach($target => {
                    if ($target.hasAttribute('data-caption-switcher-active')) {
                        this.setTargetAsInactive($target);
                    } else if ($target.dataset.captionSwitcherTarget === id) {
                        this.setTargetAsActive($target);
                    }
                });
            });
        });
    }
    setup() {
        this.eventBindings();
        this.setInitialActiveCaption();
    }
}
